import { Styles } from 'shared/types';

export const Wrapper: Styles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};
